export const APPOINTMENT_ROUTES = {
  AUTHENTICATE_URL: '/appointment/authenticate',
  LICENSE_PLATE_SEARCH: '/appointment/plan-appointment/license-plate-search',
  LICENSE_PLATE_SELECTION: '/appointment/plan-appointment/license-plate-selection',
  MILEAGE_INPUT: '/appointment/plan-appointment/mileage-input',
  REDIRECT_URL: '/appointment/start',
  VEHICLE_BOOKING: '/appointment/plan-appointment/vehicle-booking',
  VIN_SEARCH: '/appointment/plan-appointment/vin-search',
  VEHICLE_BOOKING_ESTABLISHMENT:
    '/appointment/plan-appointment/vehicle-booking/select-establishment',
  VEHICLE_BOOKING_APPOINTMENT: '/appointment/plan-appointment/vehicle-booking/select-appointment',
  VEHICLE_BOOKING_APPOINTMENT_DETAILS:
    '/appointment/plan-appointment/vehicle-booking/appointment-details',
  VEHICLE_BOOKING_OVERVIEW: '/appointment/plan-appointment/vehicle-booking/overview',
  VEHICLE_BOOKING_CONFIRMATION: '/appointment/plan-appointment/vehicle-booking/confirmation',
};

export type AppointmentRouteKey = keyof typeof APPOINTMENT_ROUTES;
export type AppointmentRoute = (typeof APPOINTMENT_ROUTES)[AppointmentRouteKey];
